/*
 * Module for the Results tab displayed within the Calculation Details popup on
 * the DROP Enrollment wizard's Calculation Results step
*/
rs.module("participant/benefit/setup/drop/wizard/calculationdetailsresultstab",

    ["controls/data/grid"],

    function (gridModule) {

        var _benefitClaimFasSummaryKey;

        //
        // Initialize the module
        //
        function initialize(jsSelectors, variables, backendUrls, fasSummaryGridLrsApi, fasDetailGridLrsApi) {

            // get JS selectors
            var container = $.js(jsSelectors.container);
            var fasLoadingSpinner = container.js(jsSelectors.fasLoadingSpinner);

            // On FAS Summary grid selection change, update the FAS Detail grid
            fasSummaryGridLrsApi.selectionChanged(function (values, rows) {

                if (_benefitClaimFasSummaryKey && values.length > 0 && _benefitClaimFasSummaryKey != values[0]) {

                    updateFasDetailGrid(values[0]);
                }

                _benefitClaimFasSummaryKey = values[0];
            });

            // Update the FAS detail grid
            function updateFasDetailGrid(benefitClaimFasSummaryKey) {

                fasLoadingSpinner.show();

                gridModule.update(
                    backendUrls.getFasDetailGridData,
                    {
                        benefitClaimPaymentKey: variables.benefitClaimPaymentKey,
                        benefitClaimFasSummaryKey: benefitClaimFasSummaryKey
                    },
                    fasDetailGridLrsApi.agGridApi,
                    function done() {
                        fasLoadingSpinner.hide();
                    }
                );
            }
        }

        // Exported public API
        var exports = {
            initialize
        };

        return exports;
    }
);